export interface IJobListItem {
  title: string;
  position: string;
  city: string;
  description: string;
}

/* tslint:disable:max-line-length */
export const jobsList: Array<IJobListItem> = [
  {
    title: 'senior-backend-engineer',
    position: 'Senior Backend Engineer',
    city: 'San Francisco',
    description: `
## About the Role

Pramp is looking for a Senior Backend Engineer to join the team. You'll be challenged to build new features, think on new ways to grow, craft new services as needed, and ensure a magical experience.

## About Us
At Pramp, we **KNOW** how hard it is to interview as a software developer. Have you ever noticed how irrelevant interview questions are? Do you think resumes are outdated? We are going to change industry standards, help companies see beyond resumes and make sure no one will be asked to reverse a linked list anymore.

Join us in our mission to unlock the potential of developers by bringing them together, and crafting new tools and experiences.

## Your Impact
- You will help set the direction of our company and product
- You will give engineers the opportunity to land "that job"
- You will improve the diversity of engineering teams around the globe
- You will build new engineering communities

## About You
- Consider yourself a senior developer or you have other meaningful experience
- Have experience developing server-side of modern web applications
- Are comfortable working in an undefined environment (undefined !== null)
- Enjoy working with codebases across the system and making changes across the stack
- Have strong product sensibility

## Bonus Points
- Worked at an early stage startup before
- Experience with AWS and/or Google cloud
- Experience with microservices and/or serverless architectures
- Experience with websockets or other real time technologies
- Experience with schedule oriented systems (your alarm clock doesn't count. Unless it's distributed)
- We don’t care about the stack, but you can waste no time if you’re familiar with Node.js, MongoDB, Redis & Docker containers

## Why Us?
We’re a small team, and you’ll be part of the strategic decision making, take on big challenges and work with great people. You’ll have complete ownership and trust, and you’ll be measured by the results you deliver rather than the time you spend delivering them. We’re also very fun to work with! For instance, here’s a joke:

*What's brown and sticky? A stick.*
¯\\\\ _ (ツ) _ /¯

At Pramp, we don’t just accept difference - we celebrate it, we support it, and we flourish on it for the benefit of our employees, our products and our community. Pramp is proud to be an equal opportunity workplace. We are committed to equal employment opportunity regardless of race, color, ancestry, religion, sex, national origin, sexual orientation, age, citizenship, marital status, disability, gender identity or Veteran status.
`,
  },
  {
    title: 'senior-frontend-engineer',
    position: 'Senior Frontend Engineer',
    city: 'San Francisco',
    description: `
## About the Role
Pramp is looking for a Senior Frontend Engineer to join the team. You'll be challenged to build new features, find new ways to innovate, craft new components as needed, and ensure a magical experience.

## About Us
At Pramp, we **KNOW** how hard it is to interview as a software developer. Have you ever noticed how irrelevant interview questions are? Do you think resumes are outdated? We believe we can change industry standards, help companies see beyond resumes and make sure no one will be asked to reverse a linked list anymore.

Join us in our mission to unlock the potential of developers by bringing them together, and crafting new tools and experiences.

## Your Impact
- You will help set the direction of our company and product
- You will give engineers the opportunity to land \\"that job\\"
- You will improve the diversity of engineering teams around the globe
- You will build new engineering communities

## About You
- Consider yourself a senior developer or you have other meaningful experience
- Have experience developing the client-side of modern web applications
- Have advanced experience with React
- Have experience with build processes of a web application
- Are UX oriented and have strong product sensibility
- Are comfortable working in an undefined environment (undefined !== null)
- Enjoy working with codebases across the system and making changes across the stack

## Bonus Points
- You've interviewed frontend developers
- You've worked at an early stage startup before
- We don’t care about the stack, but you can waste no time if you’re familiar with Redux & Typescript.
- Experience with Webpack
- Experience with Flow, Typescript or similar
- Experience with mobile web development

## Why Us?
We’re a small team, and you’ll be part of the strategic decision making, take on big challenges and work with great people. You’ll have complete ownership and trust, and you’ll be measured by the results you deliver rather than the time you spend delivering them. We’re also very fun to work with! For instance, here’s a joke:

*Imagine being held at gunpoint (bear with me) by a literate animal, and the only hope of rescue is (BEAR WITH ME) posting a coded message on a job description.*
¯\\\\ _ (ツ) _ /¯

At Pramp, we don’t just accept difference - we celebrate it, we support it, and we thrive on it for the benefit of our employees, our products and our community. Pramp is proud to be an equal opportunity workplace. We are committed to equal employment opportunity regardless of race, color, ancestry, religion, sex, national origin, sexual orientation, age, citizenship, marital status, disability, gender identity or Veteran status.
    `,
  },
  {
    title: 'product-design-lead',
    position: 'Product Design Lead',
    city: 'San Francisco',
    description: `
Pramp is looking for a creative, passionate and methodical Product UX Designer to join our core team in San Francisco. You will work closely with the founding team to discover and deliver value (and delight!) to a growing user base of knowledge workers.

## About Us
Pramp is a Y Combinator funded company on a mission to bring people together to unlock their full potential. By intelligently matching knowledge workers from around the world over video chat and other collaboration tools, we foster learning and knowledge sharing at unprecedented scale.

We offer a free peer-to-peer mock interviewing platform for software engineers. Pramp was born out of our need. Engineers ourselves, we were frustrated by the lack of effective options to prepare for coding interviews. Pramp’s adoption was swift. We have already paired tens of thousands of engineers to practice coding interviews together and are growing fast.

Peer-to-peer mock interviews, however, is just the beginning. We’re building a world where Pramp enables anyone to gain (and share) new knowledge in real time and at no cost by pairing them with other people over common interests.

## About The Role
- Lead and architect Pramp’s conceptual, interactive and visual UX
- Design simple, easy-to-use flows and experiences that delight our users
- Design landing pages and ad related assets to support Marketing initiatives
- Work with the Heads of Product and Engineering to quickly prototype experiments
- Constantly participate in customer discovery to validate the UX prior to delivery
- Deliver solutions from low to high fidelity (sketches to final asset delivery)
- Execute in a fast-paced and highly fluid environment


## About You
You’re awesome! But also, you need to have:
- 4+ years of experience designing and shipping products that customers love
- Experienced in responsive web design (mobile is a plus)
- Mastery in basic principles of visual design and typography
- Familiarity with agile and lean product development methodologies
- Strong product sensibility and an holistic view of end to end experience
- The ability to drive design decisions with minimal direction
- A strong online portfolio showcasing your work
- A strong visual aesthetic
- A strong sense of ownership

Also, you’re:
- Comfortable and proactive with communication
- Collaborative and enjoyable to work with (we are a small team and spend a lot of time together!)

Bonus Points:
- Hands-on experience with HTML, CSS, and JavaScript
- Marketing communications design
- Brand strategy and/or logo design
- Experience designing for mobile
- Entrepreneurship or small startup experience
- Experience managing contractors for ad-hoc tasks

## Why Us?
We’re a small team, and you’ll be part of the strategic decision making, take on big challenges and work with great people. You’ll have complete ownership and trust, and you’ll be measured by the results you deliver rather than the time you spend delivering them. We’re also very fun to work with! For instance, here’s a joke:

*What do you call a lonely cheese? Provolone!*
¯\\\\ _ (ツ) _ /¯

At Pramp, we don’t just accept difference - we celebrate it, we support it, and we thrive on it for the benefit of our employees, our products and our community. Pramp is proud to be an equal opportunity workplace. We are committed to equal employment opportunity regardless of race, color, ancestry, religion, sex, national origin, sexual orientation, age, citizenship, marital status, disability, gender identity or Veteran status.
    `,
  },
];
/* tslint:enable:max-line-length */
